import { AuditTemplateApi } from "~/api/AuditTemplate";

export function useAuditTemplateApi(): AuditTemplateApi {
    const auditTemplateApi = new AuditTemplateApi(useHttpClient());
    
  return auditTemplateApi;
}